module.exports = __webpack_public_path__ + "img/silver.0206def2.jpeg";